export default __webpack_public_path__ + "static/media/stop-light.70017281.svg";